import axios from "axios";

// Smart backend URL detection:
// - In production (custom domain), use the current origin
// - In preview/development, use the env variable
const getBackendUrl = () => {
  const currentHost = window.location.hostname;
  
  // If on a custom domain (not emergent preview), use current origin
  if (currentHost && !currentHost.includes('preview.emergentagent.com') && !currentHost.includes('localhost')) {
    return window.location.origin;
  }
  
  // Otherwise use env variable
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

const BACKEND_URL = getBackendUrl();
const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

/**
 * Parse API error response into a human-readable message
 * Handles FastAPI validation errors (array of objects) and string errors
 */
export function parseApiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  
  if (typeof detail === "string") {
    return detail;
  }
  
  if (Array.isArray(detail)) {
    // FastAPI validation errors
    return detail.map((err) => {
      if (typeof err === "string") return err;
      return err.msg || JSON.stringify(err);
    }).join("\n");
  }
  
  if (typeof detail === "object" && detail.msg) {
    return detail.msg;
  }
  
  return fallback;
}

export function timeAgo(dateInput) {
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  const diff = Date.now() - date.getTime();
  const seconds = Math.floor(diff / 1000);
  if (seconds < 10) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min${minutes === 1 ? "" : "s"} ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours === 1 ? "" : "s"} ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}

export function truncate(text, max = 120) {
  if (!text) return "";
  return text.length > max ? `${text.slice(0, max - 1)}…` : text;
}
